import React from 'react'

function Channel() {
  return (
    <h1 style={{textAlign:'center'}}>Channel</h1>
  )
}

export default Channel